import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Glyphicon, Button, Modal } from 'react-bootstrap';

class ConfirmDialog extends Component {
  static propTypes = {
    massage: React.PropTypes.string,
    reject: React.PropTypes.func,
    resolve: React.PropTypes.func,
    dispose: React.PropTypes.func,
  }
  
  state = {
    show: true,
  }

  dismiss = () => {
    this.setState({show: false}, () => this.props.dispose());
  }

  process = () => {
    this.setState({show: false}, () => this.props.resolve());
  }

  cancel = () => {
    this.setState({show: false}, () => this.props.reject())
  }
  
  render() {
    return (
      <Modal show={this.state.show} onHide={this.dismiss} className="confirm-dialog">
        <Modal.Body>
          <Glyphicon glyph="exclamation-sign" />
          {this.props.message}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" className="pull-left" onClick={this.process}>確認</Button>
          <Button onClick={this.cancel}>取消</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const confirm = (props) => {
  const wrapper = document.body.appendChild(document.createElement('div'));
  const confirmation = new Promise((resolve, reject) => {
    try {
      ReactDOM.render(
        <ConfirmDialog resolve={resolve} reject={reject} dispose={dispose} {...props}/>, 
        wrapper);
    } catch (e) {
      console.error(e);
    }
  });

  function dispose() {
    ReactDOM.unmountComponentAtNode(wrapper);
    wrapper.remove();
  }

  return confirmation.then((result) => {
    dispose();
    return result;
  }, (result) => {
    dispose();
    return Promise.reject(result);
  });
}

export default function(message) {
  return confirm({message});
}


// WEBPACK FOOTER //
// ./src/components/Dialog/Confirm.js